export const APP_STORE_URL = "https://apps.apple.com";
export const PLAY_STORE_URL = "https://play.google.com";
